//
//
//
//
//
//
//
//
//
//

export default {
    computed: {
        urgentTel() {
            return this.$store.state.urgentTel
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/mobile/yunMobile/view.vue